// Required by /src/engines/PARTNER_PRODUCT/app/index.js
// which are partner-specific ENTRYPOINTS defined in webpack.config.js

require('./angular');
